import { render, staticRenderFns } from "./ProductCode.vue?vue&type=template&id=023217f6&scoped=true&"
import script from "./ProductCode.vue?vue&type=script&lang=js&"
export * from "./ProductCode.vue?vue&type=script&lang=js&"
import style0 from "./ProductCode.vue?vue&type=style&index=0&id=023217f6&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023217f6",
  null
  
)

export default component.exports